import type { PriceTier } from "@b2b-platform/commerce/types/price";

export const formatPrice = (price: number) => {
  const formatted = new Intl.NumberFormat("de-AT", {
    currency: "EUR",
    currencyDisplay: "symbol",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "currency",
  }).format(price / 100);

  // Move € to the front
  const euroFirst = formatted.replace("\u00A0€", "€ ");

  // Remove ",00" if it ends with it
  return euroFirst.replace(/,00$/, "");
};

export const getPriceFromPriceTiers = (
  tiers: PriceTier[] | null,
  quantity,
): Price | null =>
  tiers?.find(
    (priceTier) =>
      quantity >= priceTier.minimumQuantity &&
      quantity <= priceTier.maximumQuantity,
  )?.price;
